
export default function carSound() {

    car_sound_place_change();

    window.addEventListener('resize',function(){
        car_sound_place_change();
    });

    function car_sound_place_change() {
        var carSoundPlace = document.querySelector('.js-car-sound');
        var carSoundPlaceMobile = document.querySelector('.js-car-sound-mobile');

        if ( carSoundPlace && carSoundPlaceMobile) {

            if ( document.documentElement.clientWidth < 1025 ) {
                let top = carSoundPlaceMobile.offsetTop - 40;
                carSoundPlaceMobile.style.paddingTop = '220px';
                carSoundPlace.style.position = 'absolute';
                carSoundPlace.style.top = top + 'px';
            } else {
                carSoundPlaceMobile.style.paddingTop = '0px';
                carSoundPlace.style.position = 'relative';
                carSoundPlace.style.top = 'unset';
            }

        }
    }


    /*let carSoundHtml = '';

    if ( carSoundPlace ) {
        carSoundHtml = carSoundPlace.outerHTML;
        carSoundPlace.innerHTML = ''
    }

    if ( carSoundPlaceMobile ) {
        console.log('', carSoundPlaceMobile.innerHTML);
        carSoundPlaceMobile.innerHTML = carSoundHtml;
    } */


    const carSound = document.querySelector('.car-page__audio');
    const carSoundPlay = document.querySelector('.js-sound-play');
    const carSoundDuration = document.querySelector('.car-page__sound-time-duration');
    const carSoundCurrent = document.querySelector('.car-page__sound-time-current');
    const carSoundWave = document.querySelector('.car-page__sound-wave');
    const carSoundNavigation = document.querySelector('.js-sound-navigation');
    const carSoundVolume = document.querySelector('.js-sound-volume');
    const carSoundCovers = document.querySelectorAll('.car-page__sound-cover');



    var carSoundCurrentTime = 0;
    var carSoundInterval;
    var waveLength = 0;
    var wavePiece;
    var waveEnd;

    function waveWidth() {
        for (let cover of carSoundCovers) {
            cover.style.width = carSoundNavigation.offsetWidth + "px";
        }
    }

    waveWidth();

    window.addEventListener("resize", () => {
        waveWidth();
    });

    if (carSound && carSoundPlay && carSoundDuration && carSoundCurrent && carSoundWave && carSoundNavigation) {

        carSoundDuration.innerHTML = "0:" + Math.floor( carSound.duration );
        wavePiece = 100 / carSound.duration / 10;

        carSoundNavigation.addEventListener("click", function (event) {
            let rect = event.target.getBoundingClientRect();
            let left = 100 * event.offsetX / rect.width;

            carSound.currentTime = carSound.duration / 100 * left;
            carSoundCurrentTime = carSound.duration / 100 * left;

            rewind(left);
            waveLength = left;
            carSound.play();
            carSoundPlay.classList.add("car-page__sound-play_pause");
            clearInterval(carSoundInterval);
            intrval();
        });

        carSound.addEventListener("canplaythrough", function() {
            carSoundDuration.innerHTML = "0:" + Math.floor( carSound.duration );
            wavePiece = 100 / carSound.duration / 10;
        });



        function rewind(x) {
            carSoundWave.classList.remove("car-page__sound-wave_transition");
            carSoundWave.style.width = x + "%";
            setTimeout(() => {
                carSoundWave.classList.add("car-page__sound-wave_transition");
            }, 100);
        }

        function intrval() {
            carSoundInterval = setInterval(() => {
                if ( carSoundCurrentTime < carSound.duration ){
                    carSoundCurrentTime = +carSoundCurrentTime + 0.1;
                    if ( carSoundCurrentTime < 10 ) {
                        carSoundCurrent.innerHTML = "0:0" + Math.floor( carSoundCurrentTime );
                    } else {
                        carSoundCurrent.innerHTML = "0:" + Math.floor( carSoundCurrentTime );
                    }

                    waveLength = +waveLength + wavePiece;
                    carSoundWave.style.width = waveLength + "%";
                }
                if ( carSoundCurrentTime >= carSound.duration ){
                    carSoundPlay.classList.remove("car-page__sound-play_pause");
                    carSoundCurrentTime = 0;
                    clearInterval(carSoundInterval);
                    waveEnd = 1;
                    waveLength = 0;
                }
            }, 100);
        }




        carSoundPlay.addEventListener('click',function(){
            carSoundPlay.classList.toggle("car-page__sound-play_pause");
            carSound.paused ? carSound.play() : carSound.pause();

            if ( !carSound.paused ) {

                if ( waveEnd == 1 ) {
                    waveEnd = 0;
                    rewind(0);
                }
                intrval();

            } else {
                clearInterval(carSoundInterval);
            }


        });

    }


    if ( carSoundVolume ) {
        carSoundVolume.oninput = function(){
            carSound.volume = this.value / 100;

            var value = (this.value-this.min)/(this.max-this.min)*100;
            this.style.background = 'linear-gradient(to right, #C92F26 0%, #C92F26 ' + value + '%, #D9D9D9 ' + value + '%, #D9D9D9 100%)';
        };
    }










}
